

import { DxDataGridComponent } from 'devextreme-angular';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import {  OverviewFiltersOutput } from '../../stock/stock.service';
import { ForecastService } from '../forecast.service';



import { TaskService } from '../../task/task.service';
import { BookmarkData } from 'src/app/models/Bookmark';
import { ShareDataService } from 'src/app/services/share-data.service';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { FileExportService } from 'src/app/common/file-export-service';

import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { InfoBoxService } from 'src/app/services/info-box.service';
import { firstValueFrom } from 'rxjs';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { UtilsService } from 'src/app/services/utils.service';
import { DxDataGridBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-data-grid-bookmark-elements.operator';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import DataSource, { Options } from 'devextreme/data/data_source';

export class ActivityListData {
	public activityListId: number;
	public activityListName: string;
	public activityListGroup1: string;
	public activityListGroup2: string;
	public activityListGroup3: string;
	public activityListGroup4: string;
	public activityListGroup5: string;
	public comment: string;
}

@Component({
    selector: 'app-activity-list',
    templateUrl: './activity-list.component.html',
    styleUrls: ['./activity-list.component.scss'],
    standalone: false
})
export class ActivityListComponent implements OnInit {

	public activityListItemsGridColumns: { columnName: string; caption: string }[] = [];
	public activityListItemsGridData: any[] = [];

	public activitiesListsGridColumns: { columnName: string; caption: string }[] = [];
	public activitiesListsGridData: any[] = [];

	public activitiesListsNames: string[] = [];

	public activitiesLists: any[] = [];

	public selectedActivityList: ActivityListData;
	// public selectedActivityTableData: { activityGeneralTableData: any[][], activityGroupsTableData: any[][] };

	@ViewChild('dataGridTop', { static: false })
	public dataGridTop: DxDataGridComponent;

	@ViewChild("activitiesListsDataGrid", { static: false })
	public activitiesListsDataGrid: DxDataGridComponent;

	private readonly _componentTitle = "Activity List";
	private readonly _activityItemListIdQueryParamName = "activityItemListId";

	private _infoBoxService: InfoBoxService = inject(InfoBoxService);

	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.DEV_GetForecastActivitiesListsGridData,
				selectionSetId: SelectionSetId.ForecastActivitiesListsGridDataFilters,
			}
		)
	);

	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);

	public bookmarkElementsOperators: BookmarkElementsOperator[];

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator(
				{
					id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
					filtersOperator: () => this.pageFiltersOperator
				}
			),
			new DxDataGridBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxDataGridBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.activitiesListsDataGrid
			),
		];

		return routeData;
	}

	// public tableDataOperator: TableDataOperator = new TableDataOperator(
	// 	new SelectStatementOptions(
	// 		{
	// 			filters: async () => this.pageFiltersOperator.appliedFilters,

	// 			baseSelectStatementId: BaseSelectStatementId.DEV_GetEsoSimulateMultiGridData,
	// 			selectionSetId: SelectionSetId.EsoSimulateMultiGrid
	// 		}
	// 	)
	// );

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {

					}
				}
			}
		);
	}

	constructor(
		private titleService: Title,
		private route: ActivatedRoute,
		private location: Location,
		private router: Router,
		private taskService: TaskService,
		private notificationService: NotificationService,
		private shareDataService: ShareDataService,
		private forecastService: ForecastService,
		private fileExportService: FileExportService,
		private tableParamService: TableParameterService
	) {
		this.shareDataService.CleanData();
	}

	async ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		const $this = this;

		this.pageFiltersOperator.onFiltersApplied.subscribe(
			(_) => {
				this.pageFiltersOperator.load(
					{
						showLoadingIndicator: true,
					}
				);



				this.initializeActivitiesListsGridData('reload');
			}
		);

		await this.initializeBookmarks();

		this.loadPageData();

		//TODO: Consider making it fetching of ids instead of names here. And ommitting initializeActivitiesLists - it may take some time to get all of the lists, that is why.
		this.initializeActivitiesLists().then(
			(response) => {
				this.initializeActivitiesListsNames().then(
					(response) => {
						this.route.queryParamMap.subscribe(
							(queryParams) => {
								let activityItemListId = +queryParams.get($this._activityItemListIdQueryParamName);

								if (!activityItemListId && this.activitiesListsNames.length > 0) {

									activityItemListId = $this.activitiesLists.find((activityList) => activityList.activityListName === $this.activitiesListsNames[0]).activityListId;
								}

								console.log(`ngOnInit-> initializeActivitiesObjectClientIds - ${$this._activityItemListIdQueryParamName}:`, activityItemListId);

								$this.selectActivityList(activityItemListId);
							}
						);

						$this.initializeAutocompleteDataSource(false, "");
					},
					(error) => {
						console.error(error);

						$this.notificationService.error(error);
					}
				);
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);

		this.initializeActivitiesListsGridData('pageload');
		this.GetSettingsData();
	}

	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportForecastActivitylist").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}
	public activitiesAutocompleteDataSource: string[] = [];

	public initializeAutocompleteDataSource(filterByValue: boolean, value: string) {
		let source = this.activitiesListsNames.map((activityListName) => activityListName);



		this.activitiesAutocompleteDataSource = source;
	}

	public onUploadClick() {
		console.log("onUploadClick");
	}

	public onProductChange(event) {
		console.log("onProductChange - event:", event);

		//TODO: Consider making getActivityListByName(event);.
		this.selectActivityList(this.activitiesLists.find((activityList) => activityList.activityListName === event).activityListId);
	}

	public onActivityListItemsGridRowRemoved(event) {
		console.log("onActivityListItemsGridRowRemoved - event:", event);

		const $this = this;

		this.forecastService.deleteActivityListItemGridData(event.data.ActivityItem, this.selectedActivityList.activityListId).subscribe(
			(response) => {
				console.log("onActivityListItemsGridRowRemoved -> deleteActivityListItemGridData - response:", response);
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	compactMode = false;
	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;

		let currentState = this.dataGridTop.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGridTop.instance.state(currentState);
	}

	compactModeBottom = false;
	onToggleColumnsModeBottom() {
		this.compactModeBottom = !this.compactModeBottom;


		let currentState = this.activitiesListsDataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.activitiesListsDataGrid.instance.state(currentState);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	public dxDataGridOperatorBottom: DxDataGridOperator = new DxDataGridOperator();

	onDataGridContentReady(evt) {
		//creating new data source
		let gridData = new DataSource(
			<Options>
			{
				store: this.activitiesListsDataGrid.dataSource,
				paginate: false
			}
		);

		//Getting all Filtering
		let filterExpr = evt.component.getCombinedFilter();
		if (filterExpr != null) {
			gridData.filter(filterExpr);
		}

		//Getting all sorting
		let sortingExpres = evt.component.getDataSource().sort();
		if (sortingExpres != null) {
			gridData.sort(sortingExpres);
		}

		gridData.load().then((result) => {
        	this.activitiesAutocompleteDataSource = result.map(item => item.ActivityListName).filter(name => name != null && name !== '');
		});

		this.dxDataGridOperatorBottom.updateRowCount(evt.component);

		localStorage.setItem('grid-state-fc-activity-ls', JSON.stringify(this.activitiesListsDataGrid.instance.state()));
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	onDataGridTopContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-fc-activity-ls-top', JSON.stringify(this.dataGridTop.instance.state()));
	}

	public onFileSaving(event) {
		console.log("onFileSaving - event:", event);
	}

	private upsertActivityListItemsGridRow(event) {
		this.forecastService.saveActivityListItemGridData(event.data, this.selectedActivityList.activityListId).subscribe(
			(response) => {
				if (response) {
					this.initializeActivityListItemsGridData();
				}
			}
		);
	}

	public onActivityListItemsGridRowInserted(event) {


		this.upsertActivityListItemsGridRow(event);
	}

	public onActivityListItemsGridRowUpdated(event) {

		this.upsertActivityListItemsGridRow(event);
	}

	private upsertActivitiesListsGridRow(data) {
		this.forecastService.saveActivitiesListsGridData(data).subscribe(
			(response) => {
				this._infoBoxService.show(
					{
						message: response.message,
					}
				);

				if (response.success) {
					this.initializeActivitiesListsGridData('reload');
				}
			},
			(error) => {
				if (error.status === 409 && !error.error.success) {
					this._infoBoxService.show(
						{
							message: error.error.message,
						}
					);

					this.initializeActivitiesListsGridData('reload');
				} else {
					this.notificationService.error(error);
				}
			}
		);
	}

	private removeActivitiesListsGridRow(data) {
		this.forecastService.deleteActivitiesListsGridData(data).subscribe(
			(response) => {
				if (response.success) {
					this.initializeActivitiesListsGridData('reload');
				}
			}
		);
	}

	public onActivitiesListsGridRowInserted(event) {
		console.log("onActivitiesListsGridRowInserted - event:", event);

		this.upsertActivitiesListsGridRow(event.data);
	}

	public onActivitiesListsGridRowUpdated(event) {
		console.log("onActivitiesListsGridRowUpdated - event:", event);

		this.upsertActivitiesListsGridRow(event.data);
	}

	public onActivitiesListsGridRowRemoved(event) {
		console.log("onActivitiesListsGridRowRemoved - event:", event);

		this.removeActivitiesListsGridRow(event.data);
	}

	public clonePopUpVisible: boolean;
	public originalActivityListName: string;

	private _clonedRowData: any;

	public onActivitiesListsGridCloneRow(event) {
		console.log("onActivitiesListsGridCloneRow - event:", event);

		this._clonedRowData = Object.assign({}, event.row.data, { isClone: true });

		delete this._clonedRowData.ActivityListId;

		this.clonePopUpVisible = true;


		// //TODO: find a better solution than this custom one.




	}

	public onPopUpPrimaryButtonClicked(event) {
		this._clonedRowData.originalActivityListName = this._clonedRowData.ActivityListName;
		this._clonedRowData.ActivityListName = event.primaryValue;

		this.forecastService.saveActivitiesListsGridData(this._clonedRowData, this._clonedRowData.originalActivityListName).subscribe(
			(response) => {


				this._infoBoxService.show(
					{
						message: response.message,
					}
				);

				if (response.success) {
					this.clonePopUpVisible = false;

					this.initializeActivitiesListsGridData('reload');
				}
			},
			(error) => {
				if (error.status === 409 && !error.error.success) {
					this._infoBoxService.show(
						{
							message: error.error.message,
						}
					);

					this.initializeActivitiesListsGridData('reload');
				} else {
					this.notificationService.error(error);
				}
			}
		);
	}

	// public onActivityListsGridActionItemClicked(item: any) {
	// 	console.log("onActivityListsGridActionItemClicked - item:", item);
	// }

	public onActivitiesListsGridActionItemClicked(item: any) {
		console.log("onActivitiesListsGridActionItemClicked - item:", item);

		this.selectActivityList(item.data.ActivityListId);
	}

	public selectActivityList(activityListId: number) {


		const $this = this;

		//? Try to find activity list in cached array of acitvities before sending a request.
		this.selectedActivityList = this.activitiesLists.find((activity) => activity.activityListId === activityListId);



		if (this.selectedActivityList) {
			const url = `forecast/activity-list?${$this._activityItemListIdQueryParamName}=${this.selectedActivityList.activityListId}`;
			this.location.replaceState(url);

			console.log("selectedActivityList:", this.selectedActivityList);

			this.initializeActivityListItemsGridData();

			return;
		}



		this.forecastService.getActivityList(activityListId).subscribe(
			(response) => {
				console.log("selectActivityList -> getActivityList - response:", response);

				$this.selectedActivityList = response;

				const url = `forecast/activity-list?${$this._activityItemListIdQueryParamName}=${this.selectedActivityList.activityListId}`;
				this.location.replaceState(url);

				this.initializeActivityListItemsGridData();
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	private initializeActivitiesLists() {
		const observable$ = this.forecastService.getActivitiesLists();

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				console.log("initializeActivitiesLists - response:", response);

				$this.activitiesLists = response;

				if ($this.activitiesLists.length < 1) console.warn("Didn't receive any objects.");
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	private initializeActivitiesListsNames() {
		const observable$ = this.forecastService.getActivitiesListsNames();

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				console.log("initializeActivitiesListsNames - response:", response);

				$this.activitiesListsNames = response;

				if ($this.activitiesListsNames.length < 1) console.warn("Didn't receive any objects ids, thus couldn't select a default object to display.");
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	private initializeActivityListItemsGridData() {
		const observable$ = this.forecastService.getActivityListItemsGridData(this.selectedActivityList.activityListId);

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				$this.activityListItemsGridColumns = response.columns;
				$this.activityListItemsGridData = response.data;
			}
		);
	}

	private initializeActivitiesListsGridData(action) {
		console.log("initializeActivitiesListsGridData");

		const observable$ = this.forecastService.getActivitiesListsGridData(
			'this.filterOptions.action',
			null
		);

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				console.log("initializeActivitiesListsGridData -> getActivitiesListsGridData - response:", response);

				$this.activitiesListsGridColumns = response.columns;
				$this.activitiesListsGridData = response.data;

				console.log("initializeActivitiesListsGridData -> getActivitiesListsGridData - activitiesListsGridColumns:", $this.activitiesListsGridColumns);
				console.log("initializeActivitiesListsGridData -> getActivitiesListsGridData - activitiesListsGridData:", $this.activitiesListsGridData);

				if (action == 'pageload') {
					setTimeout(() => {
						this.dataFilter = new BookmarkData();
						this.dataFilter.BookmarkId = 0;
						this.dataFilter.name = "DefBokmk";
						this.dataFilter.pageName = this.pageName;
						this.loadBookMarkFilter();
					}, 5000)

				}
			}
		);
	}

	saveState = (state) => {
		this.shareDataService.CleanData();
		this.shareDataService.filterOptionOverview = new OverviewFiltersOutput();
		this.shareDataService.filterOptionOverview.filters = [];
		if (state != null && state.columns != null && state.columns.length > 0) {
			state.columns.forEach(element => {
				if (element.filterValues) {
					this.shareDataService.filterOptionOverview.filters.push({
						fieldName: element.dataField, operation: 4,
						value: JSON.stringify(element.filterValues)
					});
				}
			});
		}
	}

	pageName: string = "ActivityListBkDeepDive";
	dataFilter: BookmarkData;

	loadBookMarkFilterClick(data) {
		if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = data.bookmarkId;
			this.dataFilter.name = "Bokmk";
			this.dataFilter.pageName = this.pageName;
			this.loadBookMarkFilter();
		}
	}

	loadBookMarkFilter() {
		this.activitiesListsDataGrid.instance.clearFilter();
		this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
			data.forEach(element => {
				let ArrItem = JSON.parse(element.settingValue);
				if (ArrItem != null && ArrItem.length > 0) {
					this.activitiesListsDataGrid.instance.beginUpdate();
					this.activitiesListsDataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
					this.activitiesListsDataGrid.instance.columnOption(element.fieldName, 'filterValues', ArrItem);
					this.activitiesListsDataGrid.instance.endUpdate();
				}
			});
		}, err => {
		});
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;

		toolbarItems.unshift({
			location: "before",
			template: "columnMode",
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}
}
